import React from "react";
import ReactDOM from "react-dom";
import App from './app';

const rootElement = document.getElementById("maintenance-plan-root");
if (rootElement) {
    ReactDOM.render(<App />, rootElement);
}